module.exports = __webpack_public_path__ + "img/foto_vaga_estagiario.888a8055.jpg";